// extracted by mini-css-extract-plugin
export var body = "styles-module--body--0Zncm";
export var image = "styles-module--image--RVHsf";
export var images = "styles-module--images--G8I6N";
export var section = "styles-module--section--3EXzU";
export var title = "styles-module--title--3658i";